import { initialState } from './state';
import { getMutationsDeclarations, buildMutations } from '../../utils/widget-editor-module-generator/mutations-generator';

export const {
	SET_EDIT_FIELD,
	SET_FIELD,
	SET_WIDGET_ID,
	SET_WIDGET_TITLE,
	DELETE_WIDGET,
	SET_WIDGET_METADATA,
	SET_WIDGET,
	UPDATE_WIDGET,
	SET_EDIT_FIELD_OPTIONS,
	SET_WIDGET_PROMISE,
	SET_WIDGET_WORKFLOW_VERSION_ID,
	IS_SAVING,
} = getMutationsDeclarations();

const mutations = buildMutations(initialState);

export default mutations;
